// <auto-generated>
// Code generated by EDHC (R) Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is
// regenerated.
// Hash: -1763569011
// </auto-generated>
import {
  HttpClient,
  HttpParams,
  HttpHeaders,
  HttpEventType,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

import { Observable, Subject, Subscription } from 'rxjs';
import { SmartListResult, SmartListCriteria } from 'carehub-shared/smartlist';
import { Utils } from 'carehub-shared/utils';

import { EntityAudit } from './models/common/entityaudit';

export interface getAudits_Filter {
  providerId: string;
  anesthesiologistId: string;
  facilityId: string;
  contractId: string;
  providerGroupId: string;
}

@Injectable({
  providedIn: 'root',
})
export class AuditApiService {
  constructor(protected http: HttpClient) {}

  getAudits(
    criteria?: SmartListCriteria,
    queryParams?: Partial<getAudits_Filter>
  ): Observable<SmartListResult<EntityAudit>> {
    let url = environment.chiliSauceApiRoot + `/api/Audit`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<EntityAudit>>(url, { params: params });
  }
}
